























import DraggableWidget from '@/components/util/DraggableWidget.vue';

import { Component, Vue } from 'vue-property-decorator';
import { Property } from 'performo-api';

@Component({ components: { DraggableWidget } })
export default class SystemNoteWidget extends Vue {
  get property(): Property {
    return this.$store.getters.currentProperty;
  }
}
Vue.component('SystemNoteWidget', SystemNoteWidget);
